(() => {
  const content = document.querySelector('.article-template__content');
  if (!content) return;

  const normalizeId = (value) => (value || '')
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 72);

  const headings = [...content.querySelectorAll('h2, h3')]
    .filter(h => (h.textContent || '').trim().length > 2);

  if (headings.length >= 4) {
    const used = new Set();
    headings.forEach((heading, index) => {
      let id = heading.id || normalizeId(heading.textContent) || 'abschnitt-' + (index + 1);
      let unique = id;
      let i = 2;
      while (used.has(unique) || document.getElementById(unique)) {
        if (heading.id === unique) break;
        unique = id + '-' + i++;
      }
      heading.id = unique;
      used.add(unique);
    });

    const nav = document.createElement('nav');
    nav.className = 'dlm-article-toc page-width page-width--narrow';
    nav.setAttribute('aria-label', 'Inhaltsverzeichnis');

    const details = document.createElement('details');
    details.className = 'dlm-article-toc__details';
    if (window.matchMedia('(min-width: 990px)').matches) details.open = true;

    const summary = document.createElement('summary');
    summary.className = 'dlm-article-toc__summary';
    summary.textContent = 'In diesem Artikel';

    const list = document.createElement('ol');
    list.className = 'dlm-article-toc__list';

    headings.forEach(heading => {
      const item = document.createElement('li');
      item.className = heading.tagName === 'H3' ? 'dlm-article-toc__item dlm-article-toc__item--sub' : 'dlm-article-toc__item';
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      link.addEventListener('click', () => {
        if (window.matchMedia('(max-width: 749px)').matches) details.open = false;
      });
      item.appendChild(link);
      list.appendChild(item);
    });

    details.append(summary, list);
    nav.appendChild(details);
    content.parentNode.insertBefore(nav, content);
  }

  content.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', () => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) target.setAttribute('tabindex', '-1');
    });
  });
})();